import * as React from 'react';

import classNames from 'classnames';

import {Body} from '../typography/body';
import {useRefObserver} from '../utils/hooks/use-ref-observer';

import styles from './select-picker-label.module.css';

export type SelectOption = {
    label: string;
    value: string;
};

type Props = {
    options: SelectOption[];
    selectedOption: SelectOption | null | undefined;
    onChange: (option: SelectOption) => void;
    isDisabled?: boolean;
    color?: 'blue' | 'dark';
    size?: 'small' | 'normal';
};

export function SelectPickerLabel(props: Props) {
    const {color = 'dark', size = 'normal'} = props;

    const selectRef = React.useRef<HTMLSelectElement | null | undefined>(null);
    const {isHovered} = useRefObserver(selectRef, ['isHovered']);

    const handleChange = (event: React.SyntheticEvent<HTMLSelectElement>) => {
        const selectedValue = event.currentTarget.value;
        const selectedOption = props.options.find((option) => option.value === selectedValue);

        if (selectedOption) {
            props.onChange(selectedOption);
        }
    };

    return (
        <div
            className={classNames(styles['select-picker-label'], {
                [styles.disabled]: props.isDisabled,
            })}
        >
            <Body
                color={color}
                underline={(isHovered && !props.isDisabled) || false}
                size={size}
                nowrap={true}
            >
                {props.selectedOption ? props.selectedOption.label : 'Select an option'}
            </Body>
            <select
                // @ts-expect-error
                ref={selectRef}
                value={(props.selectedOption && props.selectedOption.value) || ''}
                onChange={handleChange}
                disabled={props.isDisabled}
                onClick={(e) => e.stopPropagation()}
                className={styles['invisible-select']}
            >
                {!props.selectedOption && (
                    <option value='' disabled={true}>
                        Please select
                    </option>
                )}
                {props.options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
                {props.selectedOption &&
                    !props.options.some(
                        (option) =>
                            option.value === (props.selectedOption && props.selectedOption.value)
                    ) && (
                        <option value={props.selectedOption.value} disabled={true}>
                            {props.selectedOption.label}
                        </option>
                    )}
            </select>
        </div>
    );
}
